module.exports = {
    loadImage(img_src) {
        return new Promise( (resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.onload = () => resolve(img);
            img.onerror = e => reject(e);
            img.src = img_src;
        });
    }
};
